/* eslint-disable react/prop-types */
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import { TextField } from 'formik-material-ui'
import Tooltip from '@material-ui/core/Tooltip'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import React from 'react'
import { Formik, Form, Field } from 'formik'
import { useDispatch } from 'react-redux'

import { fetchLaundries } from '../LaundryActions'

export default function Filter(props) {
  const dispatch = useDispatch()
  const { classes } = props

  return (
    <Tooltip title="Filter list">
      <PopupState variant="popover" popupId="demo-popup-popover">
        {popupState => (
          <div>
            <IconButton aria-label="filter list" {...bindTrigger(popupState)}>
              {/* <BadgeGlobal form={form} items={items}> */}
              <FilterListIcon />
              {/* </BadgeGlobal> */}
            </IconButton>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Box p={2} className={classes.popover}>
                <div className={classes.root}>
                  <Formik
                    initialValues={{
                      email: '',
                      name: '',
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      setSubmitting(false)
                      dispatch(fetchLaundries(null, values))
                    }}
                  >
                    {({ submitForm, isSubmitting }) => (
                      <Form className={classes.form}>
                        <Grid
                          container
                          className={classes.gridContainer}
                          spacing={1}
                          justify="center"
                          alignItems="center"
                        >
                          <Grid item xs={6}>
                            <Field
                              component={TextField}
                              label="Nome"
                              margin="dense"
                              className={classes.inputFilter}
                              variant="outlined"
                              fullWidth
                              name="name"
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <Field
                              component={TextField}
                              label="Email"
                              margin="dense"
                              className={classes.inputFilter}
                              variant="outlined"
                              fullWidth
                              name="email"
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <Field
                              component={TextField}
                              label="Cidade"
                              margin="dense"
                              className={classes.inputFilter}
                              variant="outlined"
                              fullWidth
                              name="city"
                            />
                          </Grid>

                          <Grid item xs>
                            <Button
                              color="primary"
                              fullWidth
                              type="submit"
                              variant="contained"
                              className={classes.submit}
                              onClick={popupState.close}
                            >
                              <SearchIcon />
                              {` Filtrar`}
                            </Button>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </div>
              </Box>
            </Popover>
          </div>
        )}
      </PopupState>
    </Tooltip>
  )
}
